import React from "react";
import Select from "react-select";

const styles = {
  container: (base) => ({ ...base, minWidth: 0, flex: 1 }),
  control: (base, state) => ({ ...base, minHeight: 48, borderRadius: 10, borderColor: state.isFocused ? "#2563eb" : "#cbd5e1", boxShadow: state.isFocused ? "0 0 0 3px #dbeafe" : "none", backgroundColor: "#fff", padding: "2px 4px" }),
  valueContainer: (base) => ({ ...base, padding: "4px 10px", gap: 4 }),
  placeholder: (base) => ({ ...base, color: "#64748b", fontSize: 14 }),
  singleValue: (base) => ({ ...base, color: "#163653", fontSize: 14 }),
  menuPortal: (base) => ({ ...base, zIndex: 1060, fontFamily: '"Poppins", sans-serif' }),
  menu: (base) => ({ ...base, borderRadius: 10, border: "1px solid #dbe3ed", boxShadow: "0 12px 32px rgba(15,23,42,.16)", overflow: "hidden" }),
  menuList: (base) => ({ ...base, padding: 6 }),
  option: (base, state) => ({ ...base, minHeight: 44, padding: "12px", borderRadius: 6, fontSize: 13, overflowWrap: "anywhere", backgroundColor: state.isSelected ? "#163653" : state.isFocused ? "#eff6ff" : "#fff", color: state.isDisabled ? "#94a3b8" : state.isSelected ? "#fff" : "#334155", cursor: state.isDisabled ? "not-allowed" : "pointer" }),
  multiValue: (base) => ({ ...base, backgroundColor: "#eff6ff", borderRadius: 6 }),
  multiValueLabel: (base) => ({ ...base, color: "#163653", fontSize: 12 }),
};

export default function UsersSelect({ styles: suppliedStyles = {}, options = [], ...props }) {
  const [portal, setPortal] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [, updatePosition] = React.useState(0);
  // Keep the menu inside the modal's focus boundary, outside its scrolling body.
  const containerRef = React.useCallback((node) => {
    if (node) setPortal(node.closest(".modal") || document.body);
  }, []);
  React.useEffect(() => {
    if (!open) return;
    const outsideMenu = (event) => !event.target?.closest?.(".users-select__menu");
    const reposition = (event) => { if (outsideMenu(event)) updatePosition((value) => value + 1); };
    const closeOnUserScroll = (event) => { if (outsideMenu(event)) setOpen(false); };
    // Focusing a searchable input can scroll its modal or open a mobile
    // keyboard. Reposition for those changes; close on an actual scroll gesture.
    window.addEventListener("scroll", reposition, true);
    window.addEventListener("resize", reposition);
    window.addEventListener("wheel", closeOnUserScroll, { capture: true, passive: true });
    window.addEventListener("touchmove", closeOnUserScroll, { capture: true, passive: true });
    window.visualViewport?.addEventListener("resize", reposition);
    window.visualViewport?.addEventListener("scroll", reposition);
    return () => {
      window.removeEventListener("scroll", reposition, true);
      window.removeEventListener("resize", reposition);
      window.removeEventListener("wheel", closeOnUserScroll, true);
      window.removeEventListener("touchmove", closeOnUserScroll, true);
      window.visualViewport?.removeEventListener("resize", reposition);
      window.visualViewport?.removeEventListener("scroll", reposition);
    };
  }, [open]);
  const combinedStyles = { ...suppliedStyles };
  Object.keys(styles).forEach((key) => {
    combinedStyles[key] = (base, state) => styles[key](suppliedStyles[key] ? suppliedStyles[key](base, state) : base, state);
  });
  return <div ref={containerRef} className="users-select-container">
    <Select {...props} options={options.filter((option) => option.label || !option.isDisabled)}
      aria-label={props["aria-label"] || props.placeholder || "Pilih opsi"}
      classNamePrefix="users-select" styles={combinedStyles}
      menuPortalTarget={portal} menuPosition="fixed" menuPlacement="auto"
      maxMenuHeight={Math.min(240, Math.max(100, ((window.visualViewport?.height || window.innerHeight) - 48) / 2))}
      menuShouldScrollIntoView={false} menuIsOpen={open} onMenuOpen={() => setOpen(true)} onMenuClose={() => setOpen(false)}
      noOptionsMessage={() => "Pilihan tidak ditemukan"} />
  </div>;
}
